import { StyleSheet } from 'react-native';

import { withTypography } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const inputBorderRadius = Number.parseInt(getDesignToken('border-radius-input'), 10);
const inputBorderWidth = Number.parseInt(getDesignToken('border-width-input'), 10);

export const LoadingText = withTypography({
  bold: true,
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
  style: {
    margin: 0,
  },
});

export const ModalTitle = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const AddressInfoLine = withTypography({
  variant: 'headerThree',
  style: {
    margin: 0,
    marginBottom: spacing.$1,
    marginTop: spacing.$5,
  },
});

export const AliasOptions = withTypography({
  variant: 'headerFour',
  style: {
    includeFontPadding: false,
    margin: 0,
    marginBottom: 0,
    textAlignVertical: 'center',
  },
});

export const AliasOptionText = withTypography({
  fontSize: 'sm',
  bold: true,
  color: primitive.$bbqBrown,
});

export const AliasOptionTextSelected = withTypography({
  fontSize: 'sm',
  bold: true,
  color: primitive.$white,
});

export const deliveryAddressFormHeaderStyles = StyleSheet.create({
  modalHeading: {
    paddingVertical: 16,
    paddingHorizontal: 12,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  side: {
    width: '20%',
    alignItems: 'flex-start',
  },
  center: {
    width: '60%',
    alignItems: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: primitive.$bbqBrown,
    textAlign: 'center',
  },
});

export const DialogStyles = StyleSheet.create({
  headingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  bodyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 24,
    paddingBottom: 16,
  },
});

export const lockInputStyle = StyleSheet.create({
  lockedContainer: {
    height: spacing.$12,
    paddingVertical: spacing.$0,
    borderWidth: inputBorderWidth,
    borderColor: getDesignToken('border-color-input'),
    borderRadius: inputBorderRadius,
    backgroundColor: getDesignToken('background-input-disabled'),
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing.$3,
    width: '100%',
  },
  lockedText: {
    color: getDesignToken('text-disabled'),
  },
  lockedTextMask: {
    flex: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  iconContainer: {
    flexShrink: 0,
    height: spacing.$6,
    marginLeft: spacing.$2,
    width: spacing.$6,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
